<div class="full-width" fxLayout="column" fxLayoutGap="10px">
  @if (unavailableSpaceSelected && warnOnUnavailableSelection) {
    <app-info-panel
      [message]="['You have chosen a space size which is not available for the full selected date range. Please update either your period type or selected dates.']"
      [type]="warnOnUnavailableSelection ? PanelType.ERROR : PanelType.WARN"></app-info-panel>
  }

  <ng-template mat-tab-label>
    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
      <div class="square-icon icon-smaller">
        <mat-icon svgIcon="stacked_lines"></mat-icon>
      </div>
      <span class="body-1-default">Available Space</span>
    </div>
  </ng-template>
  <div class="spaces-list full-width" [style.height]="listHeight">
    <span class="body-3-default">Choose your space size</span>
    <div class="space-item" fxLayout="column" fxLayoutGap="20px">
      <div fxLayout="column">
        <span class="body-3-default">Total available and occupied lease space</span>
        <mat-form-field class="custom-text-autofill" appearance="outline" style="width: 100%; max-width: none">
          <input class="text-right" matInput type="text" [value]="availableSpace.totalSpace + ' m²'" disabled>
        </mat-form-field>
      </div>

      <div fxLayout="column">
        <span class="body-3-default">Enter space size to reserve</span>
        <mat-form-field appearance="outline" class="custom-text-field" style="width: 100%;">
          <input class="text-right" matInput type="number" [formControl]="reservedSpaceControl">
          <span class="pr-10" matSuffix>/ {{availableSpace.availableSpace}} m²</span>
          <mat-error class="link-error">{{ errorMessage }}</mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>
